import React from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "../lib/categories";
import { ShieldCheck, Truck, RotateCcw, Lock } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0a0a0a] text-white mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-2 md:grid-cols-5 gap-10">
        <div className="col-span-2 md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="bg-[#002fa7] text-white px-2 py-1 font-display font-black text-lg leading-none">ML</div>
            <span className="font-display font-black text-xl tracking-tight">MerchLander.</span>
          </div>
          <p className="text-sm text-white/70 max-w-md leading-relaxed">
            An authorized multi-category retailer. Nine verticals. One destination. Every product is sourced from
            authorized distributors and ships with full manufacturer warranty.
          </p>
          <div className="grid grid-cols-2 gap-4 mt-8 max-w-md">
            {[
              { icon: ShieldCheck, t: "Authorized Dealer" },
              { icon: Truck, t: "Fast Shipping" },
              { icon: RotateCcw, t: "30-Day Returns" },
              { icon: Lock, t: "Secure Checkout" },
            ].map((b) => (
              <div key={b.t} className="flex items-center gap-2 text-xs text-white/80">
                <b.icon size={16} className="text-[#ff3b30]" /> {b.t}
              </div>
            ))}
          </div>
        </div>

        <div className="md:col-span-2">
          <div className="rh-overline text-white/50 mb-4">Categories</div>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.slug}><Link to={`/shop/${c.slug}`} className="text-white/80 hover:text-white">{c.name}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <div className="rh-overline text-white/50 mb-4">Support</div>
          <ul className="space-y-2 text-sm text-white/80">
            <li>Contact</li>
            <li>Shipping</li>
            <li>Returns</li>
            <li>Warranty</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between text-xs text-white/50">
          <span className="font-mono">© {new Date().getFullYear()} MERCHLANDER · ALL RIGHTS RESERVED</span>
          <span className="font-mono">v1.0 · BUILT WITH PRECISION</span>
        </div>
      </div>
    </footer>
  );
}
